/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiptFieldResponse
 */
export interface ReceiptFieldResponse {
    /**
     * 
     * @type {string}
     * @memberof ReceiptFieldResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReceiptFieldResponse
     */
    value?: string | null;
}

/**
 * Check if a given object implements the ReceiptFieldResponse interface.
 */
export function instanceOfReceiptFieldResponse(value: object): value is ReceiptFieldResponse {
    return true;
}

export function ReceiptFieldResponseFromJSON(json: any): ReceiptFieldResponse {
    return ReceiptFieldResponseFromJSONTyped(json, false);
}

export function ReceiptFieldResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptFieldResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'value': json['value'] === undefined ? undefined : json['value'] === null ? null : json['value'],
    };
}

export function ReceiptFieldResponseToJSON(json: any): ReceiptFieldResponse {
    return ReceiptFieldResponseToJSONTyped(json, false);
}

export function ReceiptFieldResponseToJSONTyped(value?: ReceiptFieldResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

